import '../../scripts/common';

import '../../scripts/validation';

import Field from '../base/Field';
import Select from '../base/Select';
import Component from '../base/Component';

import './styles.css';

/**
 * Форма обратной связи.
 */
export default class AskQuestion extends Component {
    static className = 'AskQuestion';
}

$(() => {
    Field.create();
    initSelect();
});

function initSelect() {
    const selectQuestionObj = new Select($('.select--ask-question-select'));
    selectQuestionObj.init({
        isSearch: false,
    });
}
